// Import your dependencies in proper order
import "./lib/jquery-3.6.0.js";
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init({
	duration: 4000,
	easing: "ease-in-out",
	once: true,
	mirror: false,
	disable: window.innerWidth < 768,
});
import "./lib/slick.js";
import "./lib/moment.js";
import "./lib/jquery.easing.min.js";
import "./lib/magnific-popup.js";
import "./lib/validator.js";
import "./lib/wow.js";
import "./lib/fancybox.js"; 

// Import your scripts
import "./scripts/header";
import "./scripts/nav";
import "./scripts/nav-mobile";
import "./scripts/desktop-megamenu";
import "./scripts/accessibility";
import "./scripts/slick";
import "./scripts/modal";
import "./scripts/product";
import "./scripts/cart";
import "./scripts/faq";
import "./scripts/mobile-search";